<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';

export interface Props {
  product?: ReadonlyDeep<
    Partial<
      openapi.AirroadJobDetailedContentOpenapi['stops'][0]['pickup_products'][0]
    >
  >;
}
const props = withDefaults(defineProps<Props>(), {
  product: () => ({}),
});
</script>

<template>
  <div
    :class="$style.newAirRoadProductSizeText"
    data-testid="newAirRoadProductSizeText"
  >
    <div :class="$style.icon">
      <v-icon icon="mdi-axis-arrow"></v-icon>
    </div>
    <div :class="$style.text">
      {{ getStrCell(props.product.width) }}&nbsp;x&nbsp;{{
        getStrCell(props.product.height)
      }}&nbsp;x&nbsp;{{ getStrCell(props.product.length) }}&nbsp;cm
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadProductSizeText {
  display: flex;
  align-items: center;
}
  .icon {
    font-size: 12px;
    margin-right: 8px;
  }
  .text {
  }
</style>
